<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">5. </span>What kind of business do you write, by <span class="red-text">PERCENTAGE</span> of annual premium? (Percentage must total 100%)
          </label>
          <div class="row pb-3">
            <div class="col-md-2">
              <label for class="orep-label mb-0 ml-1">
                <span class="mr-1">a. </span>Personal:
              </label>
            </div>
            <div class="col-md-2">
              <label for class="orep-label mb-0 ml-1">
                Auto
              </label>
              <input
                  type="number"
                  name="personalAuto" placeholder="0"
                  v-model="mgaApplication.personalAuto"
                  class="orep-text-input w-100"
                  step="0.01"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2">
              <label for class="orep-label mb-0 ml-1">
                Homeowners
              </label>
              <input
                  type="number"
                  name="personalHomeowners"
                  placeholder="0"
                  v-model="mgaApplication.personalHomeowners"
                  class="orep-text-input w-100"
                  step="0.01"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-3">
              <label for class="orep-label mb-0">
                <span class="qtn mrpx-5"></span>Other
              </label>
              <input
                  type="number"
                  name="personalOther"
                  placeholder="0"
                  v-model="mgaApplication.personalOther"
                  class="orep-text-input w-100"
                  step="0.01"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-3">
              <label for class="orep-label mb-0">
                <span class="qtn mrpx-5"></span>Explain
              </label>
              <input
                  type="text"
                  name="personalExplain"
                  v-model="mgaApplication.personalExplain"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-2">
              <label for class="orep-label mb-0 ml-1">
                <span class="mr-1">a.</span>Commercial:
              </label>
            </div>
            <div class="col-md-1">
              <label for class="orep-label mb-0 ml-1">
                Auto
              </label>
              <input
                  type="number"
                  name="commercialAuto"
                  placeholder="0"
                  v-model="mgaApplication.commercialAuto"
                  class="orep-text-input w-100"
                  step="0.01"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2">
              <label for class="orep-label mb-0 ml-1">
                Property
              </label>
              <input
                  type="number"
                  name="commercialProperty"
                  placeholder="0"
                  v-model="mgaApplication.commercialProperty"
                  class="orep-text-input w-100"
                  step="0.01"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2">
              <label for class="orep-label mb-0">
                <span class="qtn mrpx-5"></span>Liability
              </label>
              <input
                  type="number"
                  name="commercialLiability"
                  placeholder="0"
                  v-model="mgaApplication.commercialLiability"
                  class="orep-text-input w-100"
                  step="0.01"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2">
              <label for class="orep-label mb-0">
                <span class="qtn mrpx-5"></span>Package
              </label>
              <input
                  type="number"
                  name="commercialPackage"
                  placeholder="0"
                  v-model="mgaApplication.commercialPackage"
                  class="orep-text-input w-100"
                  step="0.01"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-3">
              <label for class="orep-label mb-0">
                <span class="qtn mrpx-5"></span>Worker Comp
              </label>
              <input
                  type="number"
                  name="commercialWorker"
                  placeholder="0"
                  v-model="mgaApplication.commercialWorker"
                  class="orep-text-input w-100"
                  step="0.01"
                  @input="validateBeforeSubmit()"
              >
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-2">
              <label for class="orep-label mb-0 ml-1">
              </label>
            </div>
            <div class="col-md-2">
              <label for class="orep-label mb-0 ml-1">
                Other
              </label>
              <input
                  type="number"
                  name="commercialOther"
                  placeholder="0"
                  v-model="mgaApplication.commercialOther"
                  class="orep-text-input w-100"
                  step="0.01"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4">
              <label for class="orep-label mb-0 ml-1">
                Explain
              </label>
              <input
                  type="text"
                  name="commercialExplain"
                  v-model="mgaApplication.commercialExplain"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-2">
              <label for class="orep-label mb-0 ml-1">
                <span class="mr-1">c.</span>Life & Health:
              </label>
            </div>
            <div class="col-md-2">
              <label for class="orep-label mb-0 ml-1">
                Life
              </label>
              <input
                  type="number"
                  name="kindOfBusinessLife"
                  placeholder="0"
                  v-model="mgaApplication.kindOfBusinessLife"
                  class="orep-text-input w-100"
                  step="0.01"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2">
              <label for class="orep-label mb-0 ml-1">
                Health
              </label>
              <input
                  type="number"
                  name="kindOfBusinessHealth"
                  placeholder="0"
                  v-model="mgaApplication.kindOfBusinessHealth"
                  class="orep-text-input w-100"
                  step="0.01"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-3">
              <label for class="orep-label mb-0">
                <span class="qtn mrpx-5"></span>Other
              </label>
              <input
                  type="number"
                  name="kindOfBusinessOther"
                  placeholder="0"
                  v-model="mgaApplication.kindOfBusinessOther"
                  class="orep-text-input w-100"
                  step="0.01"
                  @input="validateBeforeSubmit()"
              >

            </div>
            <div class="col-md-3">
              <label for class="orep-label mb-0">
                <span class="qtn mrpx-5"></span>Explain
              </label>
              <input
                  type="text"
                  name="kindOfBusinessExplain"
                  v-model="mgaApplication.kindOfBusinessExplain"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-8">
              <label for class="orep-label mb-0 ml-1">
                <strong>PERCENTAGE: </strong><span class="red-text" style="font-size: 20pt">{{ totalPercentage() }} %</span> (Percentage must equal 100%)
              </label>
            </div>
          </div>
        </article>

        <article class="form-heading title-section form-section flex">
          <h1 class="form-title">  BUSINESS OPERATIONS </h1>
        </article>

        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">1.</span>
                Are you engaged in any other business other than insurance?              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="otherBusinessThanInsurance"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.otherBusinessThanInsurance"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="otherBusinessThanInsurance"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.otherBusinessThanInsurance"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('otherBusinessThanInsurance')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('otherBusinessThanInsurance') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.otherBusinessThanInsurance == true || mgaApplication.otherBusinessThanInsurance === 'true'">
            <label class="orep-label text-danger">If Yes, describe the business
            </label>

            <input
                type="text"
                placeholder="Describe the business:"
                class="orep-text-input js-orep-input"
                v-if="mgaApplication.otherBusinessThanInsurance == true || mgaApplication.otherBusinessThanInsurance === 'true'"
                name="otherBusinessThanInsuranceDetails"
                v-model="mgaApplication.otherBusinessThanInsuranceDetails"
            >
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">2.</span>
                Are you controlled, owned, affiliated, or associated with any other firm, business, agency, corporation, or insurance company?              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownOtherFirm"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.ownOtherFirm"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownOtherFirm"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.ownOtherFirm"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('ownOtherFirm')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('ownOtherFirm') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.ownOtherFirm == true || mgaApplication.ownOtherFirm === 'true'">
            <label class="orep-label text-danger">If Yes, provide details
            </label>

            <input
                type="text"
                placeholder="Please explain:"
                class="orep-text-input js-orep-input"
                v-if="mgaApplication.ownOtherFirm == true || mgaApplication.ownOtherFirm === 'true'"
                name="ownOtherFirmDetails"
                v-model="mgaApplication.ownOtherFirmDetails"
            >
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">3.</span>
                During the past 3 years has the name of your agency changed or has any other business or agency been acquired, merged into, or consolidated with you?</label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="past3YearsAgencyNameChanged"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.past3YearsAgencyNameChanged"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="past3YearsAgencyNameChanged"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.past3YearsAgencyNameChanged"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('past3YearsAgencyNameChanged')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('past3YearsAgencyNameChanged') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.past3YearsAgencyNameChanged == true || mgaApplication.past3YearsAgencyNameChanged === 'true'">
            <label class="orep-label text-danger">If Yes, provide details
            </label>

            <input
                type="text"
                placeholder="Please explain:"
                class="orep-text-input js-orep-input"
                v-if="mgaApplication.past3YearsAgencyNameChanged == true || mgaApplication.past3YearsAgencyNameChanged === 'true'"
                name="past3YearsAgencyNameChangedDetails"
                v-model="mgaApplication.past3YearsAgencyNameChangedDetails"
            >
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">4. </span>
                Is all incoming mail date stamped the date it is received?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="incomingMailStamped"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.incomingMailStamped"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="incomingMailStamped"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.incomingMailStamped"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('incomingMailStamped')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('incomingMailStamped') | filterText }}</span>
            </div>
          </div>
        </article>

        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-4">
              <label for class="orep-label">
                <span class="mr-1">6.</span> How long do you maintain your records?
              </label>
            </div>
            <div class="col-md-4">
              <input
                  type="text"
                  name="howLongMaintainRecords"
                  v-model="mgaApplication.howLongMaintainRecords"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('howLongMaintainRecords')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('howLongMaintainRecords') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label">
                Years
              </label>
            </div>
          </div>
        </article>


        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">7.</span>
                Do you maintain a binder log?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="maintainBinderLog"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.maintainBinderLog"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="maintainBinderLog"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.maintainBinderLog"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('maintainBinderLog')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('maintainBinderLog') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">8.</span>
                Do you document all business related conversations?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="documentAllBusinessConversations"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.documentAllBusinessConversations"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="documentAllBusinessConversations"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.documentAllBusinessConversations"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('documentAllBusinessConversations')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('documentAllBusinessConversations') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">9.</span>
                Do you require requests from you customers that coverage be increased, reduced, or eliminated be in writing?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="coverageChangeRequest"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.coverageChangeRequest"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="coverageChangeRequest"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.coverageChangeRequest"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('coverageChangeRequest')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('coverageChangeRequest') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">11.</span>
                Do you require customers to acknowledge, in writing, the declination of uninsured/underinsured auto, earthquake, flood, wind, or other coverages that you suggest?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="acknowledgeDisaster"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.acknowledgeDisaster"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="acknowledgeDisaster"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.acknowledgeDisaster"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('acknowledgeDisaster')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('acknowledgeDisaster') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">12.</span>
                Do you use a "Power of Attorney" to represent the insured?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="doYouUsePowerOfAttorney"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.doYouUsePowerOfAttorney"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="doYouUsePowerOfAttorney"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.doYouUsePowerOfAttorney"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('doYouUsePowerOfAttorney')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('doYouUsePowerOfAttorney') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">11.</span>
                Have any companies withdrawn from you agency in the last 3 years?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="withdrawnFromAgencyLast3Years"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.withdrawnFromAgencyLast3Years"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="withdrawnFromAgencyLast3Years"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.withdrawnFromAgencyLast3Years"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('withdrawnFromAgencyLast3Years')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('withdrawnFromAgencyLast3Years') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.withdrawnFromAgencyLast3Years == true || mgaApplication.withdrawnFromAgencyLast3Years === 'true'">
            <label class="orep-label text-danger">If yes, explain
            </label>

            <input
                type="text"
                placeholder="Please Explain:"
                class="orep-text-input js-orep-input"
                v-if="mgaApplication.withdrawnFromAgencyLast3Years == true || mgaApplication.withdrawnFromAgencyLast3Years === 'true'"
                name="withdrawnFromAgencyLast3YearsDetails"
                v-model="mgaApplication.withdrawnFromAgencyLast3YearsDetails"
            >
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">12.</span>
                Do you have binding authority?            </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="haveBindingAuthority"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.haveBindingAuthority"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="haveBindingAuthority"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.haveBindingAuthority"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('haveBindingAuthority')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('haveBindingAuthority') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.haveBindingAuthority == true || mgaApplication.haveBindingAuthority === 'true'">
            <label class="orep-label text-danger">If yes, explain
            </label>

            <input
                type="text"
                placeholder="Please Explain:"
                class="orep-text-input js-orep-input"
                v-if="mgaApplication.haveBindingAuthority == true || mgaApplication.haveBindingAuthority === 'true'"
                name="haveBindingAuthorityDetails"
                v-model="mgaApplication.haveBindingAuthorityDetails"
            >
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">13.</span>
                Do you have any plans to merge with or aquire all or part of another organization?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="planToAquireAnotherOrganization"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.planToAquireAnotherOrganization"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="planToAquireAnotherOrganization"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.planToAquireAnotherOrganization"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('planToAquireAnotherOrganization')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('planToAquireAnotherOrganization') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.planToAquireAnotherOrganization == true || mgaApplication.planToAquireAnotherOrganization === 'true'">
            <label class="orep-label text-danger">If yes, explain
            </label>

            <input
                type="text"
                placeholder="Please Explain:"
                class="orep-text-input js-orep-input"
                v-if="mgaApplication.planToAquireAnotherOrganization == true || mgaApplication.planToAquireAnotherOrganization === 'true'"
                name="planToAquireAnotherOrganizationDetails"
                v-model="mgaApplication.planToAquireAnotherOrganizationDetails"
            >
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">14.</span>
                During the last 5 years has there been a change in management structure, including any additions or deletions of any principals, owners, or managers?           </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="changedManagementStructure5Years"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.changedManagementStructure5Years"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="changedManagementStructure5Years"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.changedManagementStructure5Years"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('changedManagementStructure5Years')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('changedManagementStructure5Years') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.changedManagementStructure5Years == true || mgaApplication.changedManagementStructure5Years === 'true'">
            <label class="orep-label text-danger">If yes, explain
            </label>

            <input
                type="text"
                placeholder="Please Explain:"
                class="orep-text-input js-orep-input"
                v-if="mgaApplication.changedManagementStructure5Years == true || mgaApplication.changedManagementStructure5Years === 'true'"
                name="changedManagementStructure5YearsDetails"
                v-model="mgaApplication.changedManagementStructure5YearsDetails"
            >
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <label for class="orep-label">
            <span class="mr-1">15. </span>
            List all, carriers for whom you are an MGA, MGU, or Program Administrator:          </label>
          <div class="table-scroll">
            <table width="100%">
              <thead>
              <tr>
                <th>
                  Insurance Company
                </th>
                <th>
                  Program
                </th>
                <th>
                  Number of Years
                </th>
                <th>
                  Annual Premium
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgramInsuranceCompany1"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgramInsuranceCompany1"
                  >
                </td>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgram1"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgram1"
                  >
                </td>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgramExp1"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgramExp1"
                  >
                </td>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgramPremium1"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgramPremium1"
                  >
                </td>
              </tr>
              <tr>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgramInsuranceCompany2"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgramInsuranceCompany2"
                  >
                </td>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgram2"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgram2"
                  >
                </td>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgramExp2"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgramExp2"
                  >
                </td>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgramPremium2"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgramPremium2"
                  >
                </td>
              </tr>
              <tr>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgramInsuranceCompany3"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgramInsuranceCompany3"
                  >
                </td>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgram3"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgram3"
                  >
                </td>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgramExp3"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgramExp3"
                  >
                </td>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgramPremium3"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgramPremium3"
                  >
                </td>
              </tr>
              <tr>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgramInsuranceCompany4"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgramInsuranceCompany4"
                  >
                </td>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgram4"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgram4"
                  >
                </td>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgramExp4"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgramExp4"
                  >
                </td>
                <td>
                  <input
                      type="text"
                      class="orep-text-input"
                      name="carriersProgramPremium4"
                      @input="validateBeforeSubmit()"
                      v-model="mgaApplication.carriersProgramPremium4"
                  >
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </article>
      </form>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'ibdpro-mga-application-2'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToOne()"></button>
              <button class="pagination-dots" @click="prev()"></button>
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" @click="navigateToNext('ibdpro-mga-application-4')" :disabled="!state.pageThreeIsValid"></button>
              <button class="pagination-dots" @click="navigateToNext('ibdpro-mga-application-5')" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid"></button>
              <button class="pagination-dots" @click="navigateToNext('ibdpro-mga-application-6')" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid"></button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('ibdpro-mga-application-7')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid || !state.pageSixIsValid">
              </button>
            </article>
            <button
              type="submit"
              :disabled="!state.pageThreeIsValid"
              :class="{submitDisabled: !state.pageThreeIsValid}"
              class="next-btn mont spaced pull-right"
              @click="navigateToNext('ibdpro-mga-application-4')"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "ibdpro-mga-application-3",
  computed: {
    mgaApplication() {
      return this.$store.state.mgaApplication.mgaApplication;
    },
    state() {
      return this.$store.state.mgaApplication;
    },
    errorMsg() {
      return this.$store.state.mgaApplication.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    desiredCoverage(event) {
      if(!this.mgaApplication.limitOfCoverages.find(coverage => coverage === event.target.value)) {
        if (this.mgaApplication.limitOfCoverages.length < 2) {
          this.mgaApplication.limitOfCoverages.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 2 coverages.'
          });
        }
      } else {
        this.mgaApplication.limitOfCoverages = this.mgaApplication.limitOfCoverages.filter(coverage => coverage !== event.target.value);
      }
    },

    totalPercentage(){
      return (parseFloat(this.state.mgaApplication.personalAuto) + parseFloat(this.state.mgaApplication.personalHomeowners) +
          parseFloat(this.state.mgaApplication.personalOther) +
          parseFloat(this.state.mgaApplication.commercialAuto) +
          parseFloat(this.state.mgaApplication.commercialProperty) +
          parseFloat(this.state.mgaApplication.commercialLiability) +
          parseFloat(this.state.mgaApplication.commercialPackage) +
          parseFloat(this.state.mgaApplication.commercialWorker) +
          parseFloat(this.state.mgaApplication.commercialOther) +
          parseFloat(this.state.mgaApplication.kindOfBusinessLife) +
          parseFloat(this.state.mgaApplication.kindOfBusinessHealth) +
          parseFloat(this.state.mgaApplication.kindOfBusinessOther))
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    prev() {
      this.$router.push({
        name: "ibdpro-mga-application-2"
      });
    },

    navigateToOne() {
      this.$router.push({
        name: "ibdpro-mga-application-1"
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageThreeIsValid = true;
          return;
        }
        this.state.pageThreeIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.state.mgaApplication.realEstateAgentBroker === true){
            this.state.pageTwoIsValid = true;
          }
          else {
            this.state.pageTwoIsValid = false;
            this.validateBeforeSubmit();
          }
          return;
        }
        this.state.pageTwoIsValid = true;

      });
    },
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>

.red-text {
  color: red;
}

table td, table th {
  border: 1px solid black;
}
table th {
  height: 35px;
}
table td, table th {
  text-align: center;
  max-width: 140px;
}
table input {
  width: 100%;
  text-align: center;
}
</style>

